var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout",attrs:{"flex":"dir:top box:first"}},[_c('app-header'),_c('div',{staticClass:"container",attrs:{"flex":"dir:left box:first","id":"container"}},[_c('app-sidemenu'),_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }